import type { ProductType } from '@/types/productTypes'

export interface Claim {
  aliases: string[]
  claimId: string
  contractNumber: string
  productLine: {
    fr: string
    nl: string
    en: string
  } | null
  productType: ProductType
  insurerReferences: string[]
  settlementAmount: number | null
  status: ClaimStatuses
  type: string
  statusDate: string
  expertiseDispute: boolean
  criminalFile: boolean
  lawyerFeedback: boolean
  liabilityDispute: boolean
  insurer: string
  reportingDate: string
  incidentDate: string
  licencePlate: string | null
  risks: RiskCovers[]
  documents: ClaimDocument[]
  reportResponses: ClaimReportResponse[]
  materialDamageDeductible: number | null
  theftDeductible: number | null
}

export interface RiskCovers {
  category: string
  alias: string
  covers: string[]
}

export interface ClaimDocument {
  addedAt: string
  documentType: string
  url: string
}

export enum ClaimStatuses {
  Closed = 'closed',
  Voided = 'voided',
  Reported = 'reported',
  AnalysisAndAwaitingPossibleExpertise = 'analysis_and_awaiting_possible_expertise',
  ExpertiseDispute = 'expertise_dispute',
  AwaitingReport = 'awaiting_report',
  AwaitingLiability = 'awaiting_liability',
  LiabilityDispute = 'liability_dispute',
  AwaitingCriminalFile = 'awaiting_criminal_file',
  AwaitingLawyerFeedback = 'awaiting_lawyer_feedback',
  AwaitingClosure = 'awaiting_closure',
  InProgress = 'in_progress'
}

export const ActiveClaimStatuses = [
  ClaimStatuses.Reported,
  ClaimStatuses.AnalysisAndAwaitingPossibleExpertise,
  ClaimStatuses.ExpertiseDispute,
  ClaimStatuses.AwaitingReport,
  ClaimStatuses.AwaitingLiability,
  ClaimStatuses.LiabilityDispute,
  ClaimStatuses.AwaitingCriminalFile,
  ClaimStatuses.AwaitingLawyerFeedback,
  ClaimStatuses.AwaitingClosure,
  ClaimStatuses.InProgress
]

export const ClosedClaimStatuses = [ClaimStatuses.Closed, ClaimStatuses.Voided]

export interface OptionalStatuses {
  expertiseDispute: boolean
  liabilityDispute: boolean
  awaitingCriminalFile: boolean
  awaitingLawyerFeedback: boolean
}

export interface ClaimReportResponse {
  answer: string
  question: string
}
